import liff from '@line/liff'

const LIFF_ID = import.meta.env.VITE_LIFF_ID as string | undefined

let ready = false

/** redirect กลับผ่าน liff.line.me/<id>/<path> — รักษา context ในแอป LINE (isInClient คงเป็น true) */
function liffRedirectUri(): string {
  const path = location.pathname.replace(/\/+$/, '') || ''
  return LIFF_ID ? `https://liff.line.me/${LIFF_ID}${path}` : location.href
}

/** เรียกครั้งเดียวตอนบูต — init + บังคับ login ถ้ายังไม่ล็อกอิน */
export async function initLiff(): Promise<void> {
  if (ready) return
  if (!LIFF_ID) throw new Error('ยังไม่ได้ตั้งค่า VITE_LIFF_ID')
  await liff.init({ liffId: LIFF_ID })
  if (!liff.isLoggedIn()) {
    liff.login({ redirectUri: liffRedirectUri() })
    // ค้างไว้จนกว่าจะ redirect กลับมา
    await new Promise(() => {})
  }
  ready = true
}

/** access token สำหรับส่งไป verify ที่ฝั่ง Worker — LIFF SDK รีเฟรชให้ (id_token ไม่รีเฟรช) */
export function authToken(): string {
  const t = liff.getAccessToken()
  if (!t) throw new Error('ไม่พบ token — ลองเปิดเมนูใหม่อีกครั้ง')
  return t
}

/**
 * เซสชันหมดอายุ → บังคับ login ใหม่ (มี guard กันวนใน api.ts)
 * - logout ก่อน ไม่งั้น liff.isLoggedIn()=true แต่ token หมดอายุ → liff.login() ไม่ทำอะไร
 * - redirect กลับผ่าน liff.line.me/<id> เพื่อรักษา context ในแอป LINE (isInClient คงเป็น true)
 */
export function reauth(): void {
  try {
    liff.logout()
  } catch {
    /* noop */
  }
  liff.login({ redirectUri: liffRedirectUri() })
}

/** ปิดหน้า LIFF — ปิดจริงเฉพาะตอนอยู่ในแอป LINE จริง ๆ, นอกนั้นปล่อยให้ผู้ใช้กด ✕ เอง */
export function closeWindow(): void {
  if (!isInClient()) return // เลี่ยง prompt "เปิดแอปภายนอก" ตอน context หลุด
  try {
    liff.closeWindow()
  } catch {
    /* noop */
  }
}

/** อยู่ในแอป LINE (LIFF browser) จริงไหม */
export function isInClient(): boolean {
  try {
    return liff.isInClient()
  } catch {
    return false
  }
}

export function getProfile() {
  return liff.getProfile()
}

export { liff }
